import React, { memo } from 'react';
import { StructuredTable as StructuredTableType } from '../../Dto/chatbotStructuredResponse';
import './StructuredComponents.css';

interface StructuredTableProps {
  table: StructuredTableType;
  isMobile?: boolean;
}

const StructuredTable: React.FC<StructuredTableProps> = ({ table, isMobile = false }) => {
  if (!table || !table.headers || !table.rows) {
    return null;
  }

  return (
    <div className={`chatbot-structured-table-container ${isMobile ? 'mobile' : ''}`}>
      <div className="chatbot-table-wrapper">
        <table className="chatbot-structured-table">
          <thead>
            <tr>
              {table.headers.map((header, index) => (
                <th key={index} className="chatbot-table-header">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row, rowIndex) => (
              <tr key={rowIndex} className="chatbot-table-row">
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className="chatbot-table-cell">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default memo(StructuredTable);
